import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ButtonLoader from "@Shared/components/general/button-loader.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BoardActionsDropdown",
  components: {
    ButtonLoader
  },
  props: {
    isDefaultBoard: {
      type: Boolean,
      required: true
    },
    boardView: {
      type: String,
      required: true,
      validator(value) {
        const validTypes = ["classic", "dynamic", "chart"];
        return _includesInstanceProperty(validTypes).call(validTypes, value);
      }
    },
    isOwner: {
      type: Boolean,
      required: true
    },
    trackEmails: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showEditBoard: false
    };
  },
  methods: {
    handleSelection(action, data) {
      this.$emit("select", action, data);
    },
    showCreateClient() {
      this.$parent.showCreateClient();
    }
  }
});